<template>
    <div class="invoice-popup">
        <el-dialog title="拆单商品选择" :visible.sync="visible" width="900px" class="invoice-add-popup" @close="handleCancel">
            <h5 class="">已选商品（{{Orderselected.length}}）</h5>
            <div style="text-align:right;">发货单内商品数量小于拆出数量时，按发货单内最大数量拆出</div>
            <el-table :data="goodsList" border="">
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column prop="picUrl" label="图片" width="80" align="center">
                    <template slot-scope="scope">
                        <img class="tableImg" :src="scope.row.picUrl[0]" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="barCode" label="69码" width="150" align="center"></el-table-column>
                <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="boxUnit" label="单位" width="50" align="center"></el-table-column>
                <el-table-column prop="snCodePrefix" label="SN前缀" width="100" align="center"></el-table-column>
                <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="scope">
                        <el-button @click="delClick(scope.row, scope.$index)" type="text" size="small">取消</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-button style="margin: 10px auto; display:block;" type="primary" @click="addGoods">添加拆单商品</el-button>
            <div class="popup-btm">
                <el-button class="popup-btn" type="primary" @click="confirOrder" :disabled="goodsList.length > 0 ? false : true">筛选订单</el-button>
                <el-button class="popup-btn" @click="handleCancel">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加拆单商品" :visible.sync="isAddGoods" class="invoice-add-popup">
            <h5 class="">选择商品</h5>
            <div class="flex marBottom10 marTop10">
                <el-input class="popup-select marRight10" clearable v-model="goodsInput" @input="handleSelect" placeholder="请输入商品名称/编号"></el-input>
                <el-select class="popup-select marRight10" clearable v-model="firstValue" placeholder="请选择一级分类" @change="selectEvent">
                    <el-option v-for="item in firstOptions" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
                </el-select>
                <el-select class="popup-select marRight10" clearable v-model="secondValue" placeholder="请选择二级分类" @change="selectEvent">
                    <el-option v-for="item in secondOptions" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
                </el-select>
                <el-select class="popup-select marRight10" clearable v-model="thirdValue" placeholder="请选择三级分类" @change="selectEvent">
                    <el-option v-for="item in thirdOptions" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
                </el-select>
            </div>
            <el-table :data="goodsSplitList" border @selection-change="handSelectChange">
                <el-table-column type="selection" :selectable="selectable"  width="55" align="center"></el-table-column>
                <el-table-column prop="picUrl" label="商品图片" width="80" align="center">
                    <template slot-scope="scope">
                        <img class="tableImg" :src="scope.row.picUrl[0]" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="barCode" label="69码" width="150" align="center"></el-table-column>
                <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="boxUnit" label="单位" width="50" align="center"></el-table-column>
                <el-table-column prop="snCodePrefix" label="SN前缀" width="100" align="center"></el-table-column>
            </el-table>
            <div style="text-align:right;margin-top:10px;">
                <el-pagination background @size-change="handleSizeChangeAdd" @current-change="handleCurrentChangeAdd" :current-page="pageNoAdd" :page-size="pageSizeAdd" layout="total, prev, pager, next, jumper" :total="totalCountAdd"></el-pagination>
            </div>

            <div class="popup-btm">
                <el-button class="popup-btn" type="primary" @click="addGoodsEvent">添加</el-button>
                <el-button class="popup-btn" @click="backAddGoods">返回</el-button>
            </div>
        </el-dialog>
        <el-dialog title="拆单商品选择" :visible.sync="isConfirmOrder" width="900px" class="invoice-order-popup">
            <h5 class="marBottom10">拆单发货单（{{invoiceGoodsList.length}}）</h5>
            <el-table :data="invoiceGoodsList"  max-height="250" border>
                <!-- <el-table-column type="index" label="序号" width="50" align="center"></el-table-column> -->
                <el-table-column prop="orderNo" label="订单编号" width="150" align="center"></el-table-column>
                <el-table-column prop="orderTime" label="订单日期" width="90" align="center"></el-table-column>
                <el-table-column prop="skuSummary" label="商品信息" width="100" align="center"></el-table-column>
                <el-table-column prop="buyerName" label="买家/类型" width="250" align="center">
                    <template slot-scope="scope">
                        <div>{{scope.row.buyerName}}</div>
                        <div>{{scope.row.buyerType}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="orderStatusDesc" label="发货单状态" width="100" align="center"></el-table-column>
                <el-table-column prop="currency" label="币种" width="80" align="center" ></el-table-column>
                <el-table-column prop="" label="应付" width="100" align="center" >
                    <template slot-scope="scope">
                        {{ scope.row.toPayPrice | currencyFormat(2, false, scope.row.currencySymbol) }}
                    </template>
                </el-table-column>
                <el-table-column prop="receiveName" label="实付" width="100" align="center" >
                    <template slot-scope="scope">
                        {{ scope.row.actualTotalPrice | currencyFormat(2, false, scope.row.currencySymbol) }}
                    </template>
                </el-table-column>
                <el-table-column prop="payTime" label="付款时间" width="90" align="center"></el-table-column>
                <el-table-column prop="billSourceDesc" width="90" label="订单来源" align="center"></el-table-column>
                <el-table-column prop="sourceChannelDesc"  width="90" label="订单渠道" align="center"></el-table-column>
                <el-table-column prop="" label="支付方式" width="90" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.payRecords.length>0">{{scope.row.payRecords[0].payTypeDesc}}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="splitSkuCount" label="拆分SKU" align="center" width="90">
                    <template slot-scope="scope">
                        <span :class="scope.row.splitSkuCount == scope.row.skuItems.length ? 'font-red' : 'font-blue'">{{scope.row.splitSkuCount}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button @click="delOrderSec(scope.row, scope.$index)" type="text">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align:right;margin-top:10px;">
                <el-pagination background @size-change="handleSizeOrderChange" @current-change="handleCurrentOrderChange" :current-page="pageNoOrder" :page-size="pageSizeOrder" layout="total, prev, pager, next, jumper" :total="totalCountOrder"></el-pagination>
            </div>
            <h5 class="marBottom10">拆单商品（{{goodsList.length}}）</h5>
            <div style="text-align:right;">发货单内商品数量小于拆出数量时，按发货单内最大数量拆出</div>
            <el-table :data="goodsList" border height="200">
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column prop="picUrl" label="图片" width="80" align="center">
                    <template slot-scope="scope">
                        <img class="tableImg" :src="scope.row.picUrl[0]" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="barCode" label="69码" width="150" align="center"></el-table-column>
                <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="boxUnit" label="单位" width="50" align="center"></el-table-column>
                <el-table-column prop="snCodePrefix" label="SN前缀" width="100" align="center"></el-table-column>
                <el-table-column prop="splitNum" label="拆分数量" width="80" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.saveNum">
                            <el-input class="order-popup-input" v-model="scope.row.splitNum" placeholder=""></el-input>
                        </span>
                        <span v-else>{{'全部: '+scope.row.splitNum}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.saveNum" @click="reviseClick(scope.row, scope.$index, 1)" type="text" size="small">保存</el-button>
                        <el-button v-else @click="reviseClick(scope.row, scope.$index, 2)" type="text" size="small">修改</el-button>
                        <el-button @click="delClick(scope.row, scope.$index)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="popup-btm">
                <el-button class="popup-btn" type="primary" @click="confirInvoice">确认拆单</el-button>
                <el-button class="popup-btn" @click="isConfirmOrder = false">返回</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { OrderApi } from "@/modules/server-api/commodity-sys/order";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        Orderselected: {
            type: Array,
            default: () => [],
        },
    },
    data(){
        return{
            goodsList: [], //商品列表
            goodsSplitList: [], //拆分商品列表
            selectGoodsList: [], //选中的商品列表
            invoiceGoodsList: [], //拆单发货单列表
            orderGoodsList: [], //拆单商品
            orderNosNotIn: [], //删除拆单商品列表
            goodsInput: '',
            firstValue: '',
            secondValue: '',
            thirdValue: '',
            firstOptions: [],
            secondOptions: [],
            thirdOptions: [],
            isAddGoods: false, //添加选择商品
            isConfirmOrder: false, //确认订单
            pageshow:true,
            pageNoAdd:1,
            pageSizeAdd: 5,
            pageNoOrder: 1,
            pageSizeOrder: 10,
            totalCountAdd: 0,
            totalCountOrder: 0,
            totalCountAll: 0,
            currencyTypeList:[
                {id: 'RMB', label: 'RMB', symbol:'￥'},
                {id: 'USD', label: 'USD', symbol:'$'}
            ],
        }
    },
    methods:{
        //返回添加商品弹窗清空筛选条件
        backAddGoods(){
          this.isAddGoods = false;
          this.firstValue = "";
          this.secondValue = "";
          this.thirdValue = "";
          this.goodsInput = "";
          this.pageNoAdd = 1;
        },
        handleCancel() {
            this.$emit("update:visible", false);
        },
        //删除商品
        delClick(val,idx) {
            let that = this;
            if(that.goodsList.length==1){
                this.$notifyError('请至少保留一项');
            }else{
                that.goodsList.map((item, index) => {
                    if(item.id == val.id){
                        that.goodsList.splice(index, 1);
                    }
                })
            }

        },
        //添加拆单商品
        addGoods(){
            let that = this;
            that.isAddGoods = true;

            that.getGoodsList();
        },
        //选择下拉框
        selectEvent(){
            let that = this;
            that.getGoodsList();
        },
        //获取拆单商品
        async getGoodsList(){
          console.log(this.goodsList)
            let that = this;
            let params = {
                pageNo: that.pageNoAdd,
                pageSize: that.pageSizeAdd,
                keyWord: that.goodsInput,
                skuTypeIdLevel1: that.firstValue,
                skuTypeIdLevel2: that.secondValue,
                skuTypeIdLevel3: that.thirdValue,
            };
            params.orderNos = that.Orderselected.map(item => { return item.orderNo})
            console.log(params);

            let resp = await OrderApi.splitOrderBySkuAddSkuList(params);
            console.log(resp)
            if(resp.code == 0 && resp.succ == 1){
                let result = resp.result;
                if(result.skuTypeLevel1.length > 0){
                    that.firstOptions = result.skuTypeLevel1;
                }
                if(result.skuTypeLevel2 && result.skuTypeLevel2.length > 0){
                    that.secondOptions = result.skuTypeLevel2;
                }
                if(result.skuTypeLevel3 && result.skuTypeLevel3.length > 0){
                    that.thirdOptions = result.skuTypeLevel3;
                }
                result.skuList.list.map(item => {
                    item.splitNum = item.oderNum;
                    item.saveNum = false;
                })
                that.goodsSplitList = result.skuList.list;
                that.totalCountAdd = result.skuList.totalCount;
            }
            that.goodsSplitList.map(item=>{
              if(this.goodsList.length!=0){
                this.goodsList.map(i=>{
                  if(item.barCode==i.barCode){
                    item.selectable=true
                  }
                })
              }
            })
        },
        selectable(row){
          if(row.selectable){
            return false
          }else{
            return true
          }
        },
        //更改每页条数
        handleSizeChangeAdd(val){
          this.pageSizeAdd = val;
          this.getGoodsList();
        },
        handleCurrentChangeAdd(val){
          this.pageNoAdd = val;
          this.getGoodsList();
        },
        //选择拆单商品
        handSelectChange(val){
            this.selectGoodsList = this.goodsList.concat(val);
        },
        //添加拆单商品
        addGoodsEvent(){
            let that = this;
            var obj = {};
            this.goodsList = this.selectGoodsList.reduce(function(item, next) {
                obj[next.id] ? '' : obj[next.id] = true && item.push(next);
                return item;
            }, []);
            that.isAddGoods = false;
        },
        //添加商品筛选
        handleSelect(val){
            console.log(val);
            // if(val === ''){
            //     this.pageNoAdd = 1;
            // }else{
            //
            // }
            this.pageNoAdd = 1;
            this.getGoodsList();
        },
        //筛选订单
        async confirOrder(){
            let that = this;
            let skulist = that.goodsList.map(item => { return item.code})
            let orderNos = that.Orderselected.map(item => { return item.orderNo})
            let params = {
                pageNo: that.pageNoOrder,
                pageSize: that.pageSizeOrder,
                data:{
                    orderNos: orderNos,
                    skuCodeList: skulist
                }
            };
            let resp = await OrderApi.getSplitOrderBill(params);
            if(resp.code == 0 && resp.succ == 1){
                let result = resp.result;
                let resData = resp.result.list;
                if(resData.length){
                    resData = resData.map(data =>{
                        let currSku = data.skuItems;
                        if(currSku.length > 0){ //获取金额标识符
                        let currCurrency = data.skuItems ? data.skuItems[0].currency : this.currencyTypeList[0].id;
                        let cIndex = this.currencyTypeList.findIndex(item => item.id == currCurrency);
                        data.currency = cIndex > -1 ?  currCurrency : this.currencyTypeList[0].id;
                        cIndex = cIndex > -1 ? cIndex : 0;
                        data.currencySymbol = this.currencyTypeList[cIndex].symbol;
                        }
                        return data;
                    });
                }
                that.orderNosNotIn = [];
                that.invoiceGoodsList = resData;
                that.totalCountOrder = result.totalCount;
                that.totalCountAll = result.totalCount;
                that.isConfirmOrder = true;
            }
        },
        //删除拆单发货单
        delOrderSec(val, idx){
            let that = this;
            if(that.invoiceGoodsList.length==1){
                that.$notifyError('请至少保留一项');
            }else{
                that.invoiceGoodsList.map((item, index) => {
                    if(item.id == val.id){
                        that.invoiceGoodsList.splice(index, 1);
                        that.orderNosNotIn.push(val);
                    }
                })
                that.totalCountOrder--;
            }



        },
        //更改每页条数
        handleSizeOrderChange(val){
          this.pageSizeOrder = val;
          this.confirOrder();
        },
        handleCurrentOrderChange(val){
          this.pageNoOrder = val;
          this.confirOrder();
        },
        //修改拆单商品
        reviseClick(val, idx, type){
            let that = this;
            that.goodsList.map((item, index) => {
                if(item.id == val.id){
                    item.saveNum = !item.saveNum
                    if(type == 1){
                        item.splitNum = item.splitNum == ''||item.splitNum < 1 ? 1 : item.splitNum;
                    }
                }
            })
        },
        //确认拆单
        async confirInvoice(){
            let that = this;
            let skulist = that.goodsList.map(item => { return item.code})
            let orderNos = that.Orderselected.map(item => { return item.orderNo})
            let skuItemlist = that.goodsList.map(item => {
                let obj = {};
                obj.skuCode = item.code;
                obj.splitNum = item.splitNum == '全部' ? 'all' : item.splitNum;
                return obj;
            })
            let delorderlist = that.orderNosNotIn.map(item => { return item.orderNo })
            let params = {
                pageNo: 1,
                pageSize: that.totalCountAll,
                data: {
                    orderNos: orderNos,
                    skuCodeList: skulist,
                    updateSkuItemList: skuItemlist,
                    orderNosNotIn: delorderlist,
                }
            }
            console.log(params)
            let resp = await OrderApi.splitOrderBySku(params)
            if(resp.code == 0 && resp.succ == 1){
                this.isConfirmOrder = false;
                this.$emit("success")
                this.$emit("update:visible", false);
            }else{
                this.$notifyError(resp.error);
            }
        }

    },
    watch:{
        firstValue(val){
            let that = this;
            that.firstValue = val;
            that.secondValue = '';
            that.thirdValue = '';
            that.secondOptions = [];
            that.thirdOptions = [];
        },
        secondValue(val){
            let that = this;
            that.secondValue = val;
            that.thirdValue = '';
            that.thirdOptions = [];
        },
        visible(val){
            if(!val){
                this.goodsList = [];
            }
        }
    }
}
</script>
<style lang="scss">
@import '@/modules/commodity-sys/commodity.scss';
.boxoverf{
.invoice-order-popup .el-table__body-wrapper{
    overflow-y: hidden;

}
}
</style>>

<style>
    .invoice-order-popup .el-table__body-wrapper{
        overflow-y: hidden!important;
    }
.order-popup-input .el-input__inner{
    text-align: center;
    padding: 0;
}
.invoice-popup .tableImg{
    width: 44px;
    height: 44px;
}
.invoice-add-popup .el-table__body-wrapper{
    min-height:150px;
    max-height: 400px;
    overflow-y: scroll;
}
.invoice-order-popup .el-table__body-wrapper{
    max-height: 250px;
    overflow-y: scroll;
}
.popup-btm{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
}
.popup-btm .popup-btn{
    width: 126px;
    margin: 0 40px;
}
.popup-select{
    width: 180px;
    text-align: left;
}
.invoice-popup .el-dialog__body{
    padding: 10px 20px 20px;
}
.font-red{
    color: #F56C6C;
}
.font-blue{
    color: #409EFF;
}

</style>
